<template>
  <div class="hexa-calculator">
    <h1>六轉進度計算機</h1>
    
    <div class="calculator-container">
      <!-- 核心進度區域 -->
      <div class="cores-section">
        <div class="core-group">
          <div class="core-type">
            <h2>技能核心</h2>
            <div class="core-item">
              <h3>技能核心 1</h3>
              <input 
                ref="skillCore"
                type="number" 
                v-model.number="coreLevels.skillCore" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('skillCore')"
                @keyup.enter="focusNextInput('skillCore')"
              >
              <div class="error-message" v-if="errors.skillCore">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>技能核心 2</h3>
              <input 
                ref="skillCore2"
                type="number" 
                v-model.number="coreLevels.skillCore2" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('skillCore2')"
                @keyup.enter="focusNextInput('skillCore2')"
              >
              <div class="error-message" v-if="errors.skillCore2">
                無法輸入0~30以外的數字
              </div>
            </div>
          </div>

          <div class="core-type">
            <h2>精通核心</h2>
            <div class="core-item">
              <h3>精通核心 1</h3>
              <input 
                ref="masteryCore1"
                type="number" 
                v-model.number="coreLevels.masteryCore1" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('masteryCore1')"
                @keyup.enter="focusNextInput('masteryCore1')"
              >
              <div class="error-message" v-if="errors.masteryCore1">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>精通核心 2</h3>
              <input 
                ref="masteryCore2"
                type="number" 
                v-model.number="coreLevels.masteryCore2" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('masteryCore2')"
                @keyup.enter="focusNextInput('masteryCore2')"
              >
              <div class="error-message" v-if="errors.masteryCore2">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>精通核心 3</h3>
              <input 
                ref="masteryCore3"
                type="number" 
                v-model.number="coreLevels.masteryCore3" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('masteryCore3')"
                @keyup.enter="focusNextInput('masteryCore3')"
              >
              <div class="error-message" v-if="errors.masteryCore3">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>精通核心 4</h3>
              <input 
                ref="masteryCore4"
                type="number" 
                v-model.number="coreLevels.masteryCore4" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('masteryCore4')"
                @keyup.enter="focusNextInput('masteryCore4')"
              >
              <div class="error-message" v-if="errors.masteryCore4">
                無法輸入0~30以外的數字
              </div>
            </div>
          </div>

          <div class="core-type">
            <h2>強化核心</h2>
            <div class="core-item">
              <h3>強化核心 1</h3>
              <input 
                ref="enhancementCore1"
                type="number" 
                v-model.number="coreLevels.enhancementCore1" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('enhancementCore1')"
                @keyup.enter="focusNextInput('enhancementCore1')"
              >
              <div class="error-message" v-if="errors.enhancementCore1">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>強化核心 2</h3>
              <input 
                ref="enhancementCore2"
                type="number" 
                v-model.number="coreLevels.enhancementCore2" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('enhancementCore2')"
                @keyup.enter="focusNextInput('enhancementCore2')"
              >
              <div class="error-message" v-if="errors.enhancementCore2">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>強化核心 3</h3>
              <input 
                ref="enhancementCore3"
                type="number" 
                v-model.number="coreLevels.enhancementCore3" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('enhancementCore3')"
                @keyup.enter="focusNextInput('enhancementCore3')"
              >
              <div class="error-message" v-if="errors.enhancementCore3">
                無法輸入0~30以外的數字
              </div>
            </div>
            <div class="core-item">
              <h3>強化核心 4</h3>
              <input 
                ref="enhancementCore4"
                type="number" 
                v-model.number="coreLevels.enhancementCore4" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('enhancementCore4')"
                @keyup.enter="focusNextInput('enhancementCore4')"
              >
              <div class="error-message" v-if="errors.enhancementCore4">
                無法輸入0~30以外的數字
              </div>
            </div>
          </div>

          <div class="core-type">
            <h2>共用核心</h2>
            <div class="core-item">
              <h3>共用核心 1</h3>
              <input 
                ref="commonCore"
                type="number" 
                v-model.number="coreLevels.commonCore" 
                min="0"
                max="30"
                placeholder="請輸入等級"
                @input="validateInput('commonCore')"
                @keyup.enter="validateAndCalculate"
              >
              <div class="error-message" v-if="errors.commonCore">
                無法輸入0~30以外的數字
              </div>
            </div>
          </div>
        </div>
        <div class="confirm-section">
          <button @click="validateAndCalculate" class="confirm-btn" :disabled="hasError">確認計算</button>
          <button @click="resetAll" class="reset-btn">重設</button>
        </div>
      </div>

      <!-- 總進度區域 -->
      <div class="total-progress-section" ref="progressSection">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <h3>總進度（不含靈魂亞努斯）</h3>
          <div class="switch-toggle">
            <button :class="{active: progressDisplayMode==='fragments'}" @click="setProgressMode('fragments')">碎片</button>
            <button :class="{active: progressDisplayMode==='soulAlder'}" @click="setProgressMode('soulAlder')">靈魂艾爾達</button>
          </div>
        </div>
        <div class="progress-bar">
          <div 
            class="progress" 
            :style="{ width: (progressDisplayMode==='fragments' ? totalProgressWithoutCommon : totalSoulAlderProgressWithoutCommon) + '%' }"
          ></div>
        </div>
        <div class="progress-text">
          <template v-if="progressDisplayMode==='fragments'">
            總進度：{{ formatProgress(totalProgressWithoutCommon) }}%<br>
            碎片進度：{{ currentFragmentsWithoutCommon }}/{{ totalFragmentsWithoutCommon }}
          </template>
          <template v-else>
            總進度：{{ formatProgress(totalSoulAlderProgressWithoutCommon) }}%<br>
            靈魂艾爾達進度：{{ currentSoulAlderWithoutCommon }}/{{ totalSoulAlderWithoutCommon }}
          </template>
        </div>

        <h3 class="mt-4">總進度（含靈魂亞努斯）</h3>
        <div class="progress-bar">
          <div 
            class="progress" 
            :style="{ width: (progressDisplayMode==='fragments' ? totalProgress : totalSoulAlderProgress) + '%' }"
          ></div>
        </div>
        <div class="progress-text">
          <template v-if="progressDisplayMode==='fragments'">
            總進度：{{ formatProgress(totalProgress) }}%<br>
            碎片進度：{{ currentFragments }}/{{ totalFragments }}
          </template>
          <template v-else>
            總進度：{{ formatProgress(totalSoulAlderProgress) }}%<br>
            靈魂艾爾達進度：{{ currentSoulAlder }}/{{ totalSoulAlder }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hexaCoreData from '@/data/hexaCoreData.json'
import { HexaCoreCalculator } from '@/utils/HexaCoreCalculator'

export default {
  name: 'SixthJobCalculator',
  data() {
    return {
      isCalculated: false,
      coreData: hexaCoreData,
      coreLevels: {
        skillCore: null,
        skillCore2: null,
        masteryCore1: null,
        masteryCore2: null,
        masteryCore3: null,
        masteryCore4: null,
        enhancementCore1: null,
        enhancementCore2: null,
        enhancementCore3: null,
        enhancementCore4: null,
        commonCore: null
      },
      errors: {
        skillCore: false,
        skillCore2: false,
        masteryCore1: false,
        masteryCore2: false,
        masteryCore3: false,
        masteryCore4: false,
        enhancementCore1: false,
        enhancementCore2: false,
        enhancementCore3: false,
        enhancementCore4: false,
        commonCore: false
      },
      hasError: false,
      totalProgress: 0,
      totalProgressWithoutCommon: 0,
      currentFragments: 0,
      totalFragments: 0,
      currentFragmentsWithoutCommon: 0,
      totalFragmentsWithoutCommon: 0,
      inputOrder: [
        'skillCore',
        'skillCore2',
        'masteryCore1',
        'masteryCore2',
        'masteryCore3',
        'masteryCore4',
        'enhancementCore1',
        'enhancementCore2',
        'enhancementCore3',
        'enhancementCore4',
        'commonCore'
      ],
      progressDisplayMode: 'fragments',
      currentSoulAlder: 0,
      totalSoulAlder: 0,
      currentSoulAlderWithoutCommon: 0,
      totalSoulAlderWithoutCommon: 0
    }
  },
  computed: {
    totalSoulAlderProgressWithoutCommon() {
      if (this.totalSoulAlderWithoutCommon === 0) return 0
      return (this.currentSoulAlderWithoutCommon / this.totalSoulAlderWithoutCommon) * 100
    },
    totalSoulAlderProgress() {
      if (this.totalSoulAlder === 0) return 0
      return (this.currentSoulAlder / this.totalSoulAlder) * 100
    }
  },
  methods: {
    resetAll() {
      // 重設所有數值
      Object.keys(this.coreLevels).forEach(key => {
        this.coreLevels[key] = null
      })
      // 重設錯誤狀態
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = false
      })
      // 重設計算結果
      this.totalProgress = 0
      this.totalProgressWithoutCommon = 0
      this.currentFragments = 0
      this.totalFragments = 0
      this.currentFragmentsWithoutCommon = 0
      this.totalFragmentsWithoutCommon = 0
      this.isCalculated = false
    },
    validateInput(key) {
      const value = this.coreLevels[key]
      if (value === null || value === '') {
        this.errors[key] = false
        this.updateHasError()
        this.calculateProgress()
        return
      }
      const numValue = Number(value)
      if (isNaN(numValue) || numValue < 0 || numValue > 30) {
        this.errors[key] = true
        this.coreLevels[key] = null
      } else {
        this.errors[key] = false
      }
      this.updateHasError()
      this.calculateProgress()
    },
    updateHasError() {
      this.hasError = Object.values(this.errors).some(error => error)
    },
    validateAndCalculate() {
      if (this.hasError) return
      
      // 驗證所有輸入值
      for (const [key, value] of Object.entries(this.coreLevels)) {
        if (value === null || value === '') {
          this.coreLevels[key] = 0
        }
      }
      this.calculateProgress()
      this.isCalculated = true
      
      // 預設顯示碎片進度
      this.progressDisplayMode = 'fragments'
      
      // 儲存到 localStorage
      localStorage.setItem('coreLevels', JSON.stringify(this.coreLevels))

      // 計算完成後滾動到進度條區域
      this.$nextTick(() => {
        this.scrollToProgress()
      })
    },
    calculateProgress() {
      const result = HexaCoreCalculator.calculateProgress(this.coreLevels, this.coreData)
      
      // 更新不含共用核心的進度
      this.totalProgressWithoutCommon = result.totalProgressWithoutCommon
      this.currentFragmentsWithoutCommon = result.currentFragmentsWithoutCommon
      this.totalFragmentsWithoutCommon = result.totalFragmentsWithoutCommon

      // 更新含共用核心的進度
      this.totalProgress = result.totalProgress
      this.currentFragments = result.currentFragments
      this.totalFragments = result.totalFragments

      // 新增：計算靈魂艾爾達
      this.currentSoulAlderWithoutCommon = this.calculateCurrentSoulAlder(false)
      this.totalSoulAlderWithoutCommon = this.calculateTotalSoulAlder(false)
      this.currentSoulAlder = this.calculateCurrentSoulAlder(true)
      this.totalSoulAlder = this.calculateTotalSoulAlder(true)
    },
    calculateCurrentSoulAlder(includeCommon) {
      let sum = 0
      const { coreLevels, coreData } = this
      const skillSoulAlder = coreData.skillCore.soulAlder
      sum += this.sumSoulAlder(skillSoulAlder, coreLevels.skillCore)
      sum += this.sumSoulAlder(skillSoulAlder, coreLevels.skillCore2)

      // 技能核心 1：0→1 為免費（資料表用通用成本，因此在加總時扣回來）
      const skillCore1Level = coreLevels.skillCore
      if (skillCore1Level && skillCore1Level >= 1 && skillSoulAlder.length > 0) {
        sum -= skillSoulAlder[0]
      }
      for (let i = 1; i <= 4; i++) {
        sum += this.sumSoulAlder(coreData.masteryCore.soulAlder, coreLevels[`masteryCore${i}`])
        sum += this.sumSoulAlder(coreData.enhancementCore.soulAlder, coreLevels[`enhancementCore${i}`])
      }
      if (includeCommon) {
        sum += this.sumSoulAlder(coreData.commonCore.soulAlder, coreLevels.commonCore)
      }
      return sum
    },
    calculateTotalSoulAlder(includeCommon) {
      let sum = 0
      const { coreData } = this
      const skillSoulAlder = coreData.skillCore.soulAlder
      sum += skillSoulAlder.reduce((a, b) => a + b, 0) * 2
      // 技能核心 1：0→1 為免費（資料表用通用成本，因此在總需求扣回來）
      if (skillSoulAlder.length > 0) sum -= skillSoulAlder[0]
      sum += coreData.masteryCore.soulAlder.reduce((a, b) => a + b, 0) * 4
      sum += coreData.enhancementCore.soulAlder.reduce((a, b) => a + b, 0) * 4
      if (includeCommon) {
        sum += coreData.commonCore.soulAlder.reduce((a, b) => a + b, 0)
      }
      return sum
    },
    sumSoulAlder(arr, level) {
      if (!level || level <= 0) return 0
      return arr.slice(0, level).reduce((a, b) => a + b, 0)
    },
    formatProgress(value) {
      return value.toFixed(3)
    },
    scrollToProgress() {
      const progressSection = this.$refs.progressSection
      if (progressSection) {
        progressSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    focusNextInput(currentKey) {
      const currentIndex = this.inputOrder.indexOf(currentKey)
      if (currentIndex < this.inputOrder.length - 1) {
        const nextKey = this.inputOrder[currentIndex + 1]
        this.$refs[nextKey].focus()
      } else {
        // 如果是最後一個輸入框，聚焦到確認按鈕
        this.$refs.confirmBtn.focus()
      }
    },
    loadFromLocalStorage() {
      const storedLevels = JSON.parse(localStorage.getItem('coreLevels'))
      if (storedLevels) {
        this.coreLevels = { ...this.coreLevels, ...storedLevels }
      }
    },
    setProgressMode(mode) {
      this.progressDisplayMode = mode
      // console.log('切換模式:', mode) // debug 用，可移除
    }
  },
  mounted() {
    // 移除初始計算
    this.loadFromLocalStorage() // 載入儲存的資料
  }
}
</script>

<style scoped>
.hexa-calculator {
  max-width: 800px;
  margin: 0 auto;
}

.hexa-calculator h1 {
  text-align: left;
  margin: 2rem 0;
}

.calculator-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.5rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.total-progress-section {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  scroll-margin-top: 2rem;
}

.total-progress-section h3 {
  color: var(--primary-color);
  margin-bottom: 1.5rem;
}

.cores-section {
  width: 100%;
}

.core-group {
  background: white;
  padding: 1.2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5rem 1.2rem;
}

.core-type {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.core-type h2 {
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.core-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.core-item:last-child {
  margin-bottom: 0;
}

.core-item h3 {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-color);
  white-space: nowrap;
}

.core-item input {
  width: 90%;
  padding: 0.4rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.85rem;
  font-family: inherit;
  transition: border-color var(--transition-speed) ease;
  text-align: center;
}

.core-item input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.confirm-section {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.confirm-btn {
  padding: 0.6rem 2rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all var(--transition-speed) ease;
  font-weight: 500;
}

.reset-btn {
  padding: 0.6rem 2rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: all var(--transition-speed) ease;
  font-weight: 500;
}

.reset-btn:hover {
  background-color: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.confirm-btn:hover {
  background-color: var(--nav-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-bar {
  height: 20px;
  background: #eee;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.progress {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.3s ease;
}

.progress-text {
  text-align: right;
  color: var(--text-color);
  opacity: 0.8;
  line-height: 1.5;
}

.mt-4 {
  margin-top: 2rem;
}

.error-message {
  flex: 1;
  color: #e74c3c;
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

.confirm-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.confirm-btn:disabled:hover {
  background-color: #ccc;
  transform: none;
  box-shadow: none;
}

.core-item input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
  border-color: #ddd;
}

.core-item input:disabled:focus {
  outline: none;
  border-color: #ddd;
  box-shadow: none;
}

@media (max-width: 768px) {
  .core-group {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
}

.active {
  background: var(--primary-color);
  color: #fff;
}

/* 新增：膠囊切換按鈕樣式 */
.switch-toggle {
  display: flex;
  background: #f0f0f0;
  border-radius: 999px;
  padding: 4px;
  gap: 4px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  margin-bottom: 1.5rem;
  
}
.switch-toggle button {
  border: none;
  background: transparent;
  color: var(--primary-color);
  padding: 6px 22px;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}
.switch-toggle button.active {
  background: var(--primary-color);
  color: #fff;
  box-shadow: 0 2px 8px rgba(74,144,226,0.08);
}
.switch-toggle button:not(.active):hover {
  background: #e6e6e6;
}
</style> 